import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import salaryType from "../../../containers/modules/hr/salary-type";

export default function SalaryTypeRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="salary-type"
      index
      element={
        <AccessControl
          name={"Salary Type List"}
          auth={authUser}
          component={salaryType}
        />
      }
    ></Route>
  );
}
